import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import AppAuth from "../components/app-auth.js";
import {shadow} from "../components/theme.js";
import Stack from "../components/stack.js";
import {withAttrs} from "../common/utils.js";
import {Title} from "../components/typo.js";
import {t} from "../common/i18n.js";
import Field from "../components/field.js";
import Button from "../components/button.js";
import Logo from "../components/logo.js";
import CSRFInput from "../components/csrf-input.js";
import Form from "../components/form.js";
import {getUrl} from "../common/universal.js";
import {Routes} from "../typings/routes.js";
export default function ResetPasswordEmailForm(props) {
  const {error} = props;
  const errors = error ? error.errors : {};
  const passwordResetPost = getUrl(Routes.postRequestResetPasswordEmail);
  return /* @__PURE__ */ React.createElement(AppAuth, {
    ...props
  }, /* @__PURE__ */ React.createElement(LogoReduced, null), /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Inner, null, /* @__PURE__ */ React.createElement(Headline, null, t("Passwort zurücksetzen")), /* @__PURE__ */ React.createElement(Form, {
    action: passwordResetPost,
    method: "post",
    error
  }, /* @__PURE__ */ React.createElement(FormInner, null, /* @__PURE__ */ React.createElement(CSRFInput, null), /* @__PURE__ */ React.createElement(Field, {
    errors,
    label: t("E-Mail"),
    type: "email",
    placeholder: t("Deine E-Mail eingeben"),
    required: true,
    name: "email"
  }), /* @__PURE__ */ React.createElement(Button, {
    type: "submit"
  }, t("E-Mail anfordern")))))));
}
const Container = styled.div`
  box-shadow: ${shadow.card};
  padding: 26px 31px;
`;
const Inner = styled(withAttrs(Stack, {spacing: "ml"}))``;
const Headline = styled(withAttrs(Title, {level: 1}))`
  font-size: 24px;
`;
const FormInner = styled(withAttrs(Stack, {}))``;
const LogoReduced = styled(Logo)`
  margin-bottom: 61px;
  z-index: 3;
  display: flex;
  justify-content: center;
`;
